import { render, staticRenderFns } from "./RelatedStatementDialog.vue?vue&type=template&id=be7e51fc&scoped=true"
import script from "./RelatedStatementDialog.vue?vue&type=script&lang=js"
export * from "./RelatedStatementDialog.vue?vue&type=script&lang=js"
import style0 from "./RelatedStatementDialog.vue?vue&type=style&index=0&id=be7e51fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7e51fc",
  null
  
)

export default component.exports